import { Component, inject, OnInit } from '@angular/core';
import { SidebarService } from '../../services/sidebar.service';
import { DeviceService } from '../../services/device.service';
import { Subscription } from 'rxjs';
import { MatMiniFabButton } from "@angular/material/button";
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from "@angular/material/form-field";
import { InfoApplicationComponent } from "../info-application/info-application.component";

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [
    MatMiniFabButton,
    InfoApplicationComponent
  ],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        subscriptSizing: 'dynamic'
      }
    }
  ]
})
export class SidebarComponent implements OnInit {
  private sidebarService: SidebarService = inject(SidebarService);
  private deviceService: DeviceService = inject(DeviceService);

  protected isMobile: boolean = this.deviceService.isMobile;

  private dataSubscription: Subscription = new Subscription();

  public async ngOnInit(): Promise<void> {
    this.checkIsSidebarCollapsed();
    this.initSubscriptions();
  }

  protected isSidebarFolded(): boolean {
    return this.sidebarService.isSidebarFolded;
  }

  public toggleSidebar(): void {
    if (this.isSidebarFolded()) {
      this.sidebarService.unfoldSidebar();
    } else {
      this.sidebarService.foldSidebar();
    }
  }

  private checkIsSidebarCollapsed(): void {
    if (this.isSidebarFolded()) {
      this.sidebarService.foldSidebar();
    } else {
      this.sidebarService.unfoldSidebar();
    }
  }

  private initSubscriptions(): void {
    this.initIsMobileSubscription();
  }

  private initIsMobileSubscription(): void {
    this.dataSubscription.add(
      this.deviceService.isMobile$.subscribe((isMobile: boolean) => {
        this.isMobile = isMobile;
      })
    );
  }
}
